module.exports = __webpack_public_path__ + "static/BIB-LOGO-BLUE-transparent_bg-afa3ae223090a8d821e3393abf713cee.png";